import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ReactComponent as TrashIcon } from '@/assets/icons/trash.svg';
import { ReactComponent as WarningIcon } from '@/assets/icons/warning.svg';

export const RemoveMessageIcon = styled(TrashIcon)`
  width: 100%;
  height: 100%;
  color: #f44336;
`;

export const RemoveMessageIconWrapper = styled.button`
  position: absolute;
  top: -4px;
  right: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 6px;
  cursor: pointer;
  border: none;
  border-radius: 50%;
  background: none;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  z-index: 1;
  transition: all 0.3s ease;

  &:hover {
    scale: 1.1;
  }
`;

export const WarningDescriptionIcon = styled(WarningIcon)`
  margin-right: 4px;
  width: 18px;
  height: 18px;
  color: #ff9800;
`;

export const WarningDescription = styled.p`
  display: flex;
  align-items: center;
  color: #868383;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.2px;
  animation: ${({ theme }) => theme.animation.bubble.show} 0.15s ease-out both;
`;

export const MessageContainer = styled.li<{ isUserMessage: boolean; hasFailed?: boolean }>`
  display: flex;
  flex-direction: column;
  will-change: transform;
  transform: translateY(10px);
  animation: ${({ theme }) => theme.animation.bubble.show} 0.15s ease-out both;

  ${({ isUserMessage }) =>
    isUserMessage
      ? css`
          align-items: flex-end;
        `
      : css`
          align-items: flex-start;
        `}

  ${({ hasFailed }) =>
    hasFailed &&
    css`
      cursor: pointer;
    `};
`;

export const MessagesContainer = styled.ul<{ hasChatFeedback: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
  margin-top: 8px;
  padding: 10px 16px;
  overflow: auto;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
  transition: opacity 0.2s ease;
  will-change: auto;
  gap: 10px;

  &::before {
    content: '';
    flex: 1;
  }

  ${({ theme }) => theme.messages.styles};

  ${({ theme, hasChatFeedback }) =>
    hasChatFeedback &&
    css`
      @media (${theme.mediaMobile}) {
        opacity: 0.1;
        overflow: hidden;

        ${theme.messages.mobile};
      }
    `}

  ${({ theme }) => css`
    @media not (${theme.mediaMobile}) {
      ${theme.messages.desktop};
    }
  `};
`;
